import React from "react";

import { Icon } from "semantic-ui-react";

import CheckInLayout from "./CheckInLayout";

// ======================= Component =======================
const PatientNotFound = () => (
  <CheckInLayout>
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "2rem",
      }}
    >
      <Icon name="user cancel" style={{ fontSize: "5rem", color: "#E5436E", margin: 0 }} />
      <div style={{ fontWeight: 700, fontSize: "2.5rem", color: "#5D5D5D" }}>
        ไม่พบข้อมูลผู้รับบริการ
      </div>
      <div style={{ fontSize: "1.5rem", color: "#999999" }}>กรุณาลองใหม่อีกครั้ง...</div>
    </div>
  </CheckInLayout>
);

PatientNotFound.displayName = "PatientNotFound";

export default PatientNotFound;
